// extracted by mini-css-extract-plugin
module.exports = {"root":"Forbidden_root__2dYwF","header":"Forbidden_header__pIjc0","name":"Forbidden_name__1JiLl","btn":"Forbidden_btn__V-wIG","icon":"Forbidden_icon__fwyiZ"};